/** `2026-W44` → the Monday that week begins, as a site writes a date. */
export function weekStart(week: string): string {
  const match = /^(\d{4})-W(\d{2})$/.exec(week)
  if (!match) return week
  const year = Number(match[1])
  const number = Number(match[2])
  // ISO week 1 is the week with 4 January in it.
  const fourth = new Date(Date.UTC(year, 0, 4))
  const monday = new Date(fourth)
  monday.setUTCDate(fourth.getUTCDate() - ((fourth.getUTCDay() + 6) % 7) + (number - 1) * 7)
  return monday.toLocaleDateString('en-US', {
    timeZone: 'UTC',
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
